// extracted by mini-css-extract-plugin
export default {"form":"AddEvent_form__n+c4w","input":"AddEvent_input__vxRoX","label":"AddEvent_label__XWAE1","datetime":"AddEvent_datetime__HfnVH"};